export const AQL_CONSTANTS = {
	LOGICAL_OPERATORS: {
		AND: '$and',
		OR: '$or'
	},
	COMPARATORS: {
		EQUALS: '$eq',
		MATCH: '$match',
		NOT_MATCH: '$nmatch'
	},
	PROPERTIES: {
		ARTIFACT_BUILD_NAME: 'artifact.module.build.name',
		ARTIFACT_BUILD_NUMBER: 'artifact.module.build.number'
	},
	LIMIT: 1500,
	INCLUSION_PROPERTIES: [
		"sha256",
		"updated",
		"modified_by",
		"created",
		"id",
		"original_md5",
		"depth",
		"actual_sha1",
		"property.value",
		"modified",
		"property.key",
		"actual_md5",
		"created_by",
		"type",
		"name",
		"repo",
		"original_sha1",
		"size",
		"path"
	],
	PATH_MAPPING_TEMPLATES: {
		REPLACE_REPO:{
			source:'original_repository/(.*)',
			target:'new_repository/$1'
		},
		ADD_FOLDER:{
			source:'(.*)/(.*)',
			target:'$1/new_folder/$2'
		},
		REPLACE_FOLDER:{
			source:'(.*)/old_folder/(.*)',
			target:'$1/new_folder/$2'
		},
	}
};


// WEBPACK FOOTER //
// ./modules/distribution/constants/aql.constants.js